import React, { useContext, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AdminDataContext } from "../useContext/AdminContext";
import API, { setAuthToken } from "../api";

const LogOut = () => {
  const { setIsLoading, setIsAuthenticated } = useContext(AdminDataContext);
  const navigate = useNavigate();
  const logout = async () => {
    setIsLoading(true);
    await API.post("/api/v1/users/logout");
    setAuthToken(null);
    localStorage.removeItem("accessToken");
    setIsLoading(false);
    setIsAuthenticated(false);

    return navigate("/login");
  };
  useEffect(() => {
    logout();
  }, []);
};

export default LogOut;
